import { useCurrentRefinements, useInstantSearch } from 'react-instantsearch';
import { onlyExcludedValuesSelected } from '@javascript/instant_search/helpers';

const EXCLUDED_FILTERS = [
  'branchID',
  'branchInfo.franchiseCodes',
  'capCode',
  'highlightedFeature',
  'query',
];

const EXCLUDED_FILTER_VALUES = [{ attribute: 'engineSize', values: [0, 7000] }];

const InstantSearchFilterButton = ({ onClick }: { onClick: VoidFunction }) => {
  const ANY_RADIUS = 1126300; // 700 miles in meters
  const { indexUiState } = useInstantSearch();
  const { items } = useCurrentRefinements({
    excludedAttributes: EXCLUDED_FILTERS,
  });

  const selectedRadius = indexUiState.configure?.aroundRadius;

  const filterCount =
    items.length + (selectedRadius && selectedRadius !== ANY_RADIUS ? 1 : 0);

  const filterCountToExclude = EXCLUDED_FILTER_VALUES.reduce(
    (count, { attribute, values }) =>
      count + (onlyExcludedValuesSelected(items, attribute, values) ? 1 : 0),
    0
  );

  const filterCountMinusExcluded = filterCount - filterCountToExclude;

  return (
    <div className="ch-display--flex">
      <button
        className="ac-instant-search__filter-button ch-btn ch-fs--2 sm:ch-fs--3 ch-bc--grey-3"
        onClick={onClick}
        type="button"
      >
        Filter & Sort
        {filterCountMinusExcluded > 0 && (
          <span className="ac-instant-search__filter-count">
            ({filterCountMinusExcluded})
          </span>
        )}
      </button>
    </div>
  );
};

export default InstantSearchFilterButton;
